import React, { useEffect } from "react";
import ResourcesTab from "../ResourcesTab";
import { useHistory } from "react-router-dom";
import { toggle } from "../../../util/common";
import { useDispatch, useSelector } from "react-redux";
import * as SecurityAssesmentAction from "../../../store/securityAssesmentService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { ApplicationState } from "../../../store";
import { IHtmlItem } from "../../../store/securityAssesmentService/types";
import { groupByKey } from "../../../util/common";
import * as services from "../../../store/service";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const SecurityAssessment = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const { t: tLang } = useTranslation();
    const requestSecurityAssesmentReview = (forcefullyRefresh: boolean) =>
        dispatch(SecurityAssesmentAction.actionCreators.requestAssesmentSummary(forcefullyRefresh));
    const isLoading = useSelector((state: ApplicationState) => {
        return state.securityAssesmentState?.isLoading;
    });
    const assessmentData = useSelector((state: ApplicationState) => {
        return state.securityAssesmentState?.assessmentData;
    });
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const groupData = useSelector((state: ApplicationState) => {
        let grpData = {};
        if (state.securityAssesmentState?.assessmentData?.listPendingAction) {
            grpData = groupByKey(
                assessmentData?.listPendingAction.filter((it) => it.ParentID !== 0),
                "ParentID"
            );
        }
        return grpData;
    });

    const onClick = () => {
        services.deleteSecurityAssessmentUserAnswers().then((data) => {
            history.push("/resources/security-assessment-wizard");
        });
    };

    useEffect(() => {
        requestSecurityAssesmentReview(false);
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const ratingList = (): IHtmlItem[] => {
        let ratings: IHtmlItem[] = [];

        ratings.push({
            title: "Above Standard",
            htmlDesc: (
                <div className="readiness_score_container">
                    <div className="readiness_score_value score_5">
                        <em className="las la-star"></em> <span>5</span>
                    </div>
                    <div className="readiness_score_content">
                        <h4 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.ratings.aboveStandard.title")}</h4>
                        <p>
                            {tLang("resourcesSection.securityAssessmentTab.ratings.aboveStandard.content")}{" "}
                        </p>
                    </div>
                </div>
            ),
        });

        ratings.push({
            title: "Industry Standard",
            htmlDesc: (
                <div className="readiness_score_container">
                    <div className="readiness_score_value score_4">
                        <em className="las la-star"></em> <span>4</span>
                    </div>
                    <div className="readiness_score_content">
                        <h4 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.ratings.industryStandard.title")}</h4>
                        <p>
                            {tLang("resourcesSection.securityAssessmentTab.ratings.industryStandard.content")}{" "}
                        </p>
                    </div>
                </div>
            ),
        });

        ratings.push({
            title: "Below Standard",
            htmlDesc: (
                <div className="readiness_score_container">
                    <div className="readiness_score_value score_3">
                        <em className="las la-star"></em> <span>3</span>
                    </div>
                    <div className="readiness_score_content">
                        <h4 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.ratings.belowStandard.title")}</h4>
                        <p>
                            {tLang("resourcesSection.securityAssessmentTab.ratings.belowStandard.content")}{" "}
                        </p>
                    </div>
                </div>
            ),
        });

        ratings.push({
            title: "Initial",
            htmlDesc: (
                <div className="readiness_score_container">
                    <div className="readiness_score_value score_2">
                        <em className="las la-star"></em> <span>2</span>
                    </div>
                    <div className="readiness_score_content">
                        <h4 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.ratings.initial.title")}</h4>
                        <p>
                            {tLang("resourcesSection.securityAssessmentTab.ratings.initial.content")}{" "}
                        </p>
                    </div>
                </div>
            ),
        });

        ratings.push({
            title: "At Risk",
            htmlDesc: (
                <div className="readiness_score_container">
                    <div className="readiness_score_value score_1">
                        <em className="las la-star"></em> <span>1</span>
                    </div>
                    <div className="readiness_score_content">
                        <h4 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.ratings.atRisk.title")}</h4>
                        <p>
                            {tLang("resourcesSection.securityAssessmentTab.ratings.atRisk.content")}{" "}
                        </p>
                    </div>
                </div>
            ),
        });

        return ratings;
    };

    const removeHtmlTags = (str: string) => {
        if (str) {
            str = str.toString();
            return str.replace(/(<([^>]+)>)/gi, "");
        }
        return "";
    };

    const parseHTML = (value: any, tagName: any) => {
        const splitedActionText = value.replace("<br />", "<br/>").split("<br/>");

        if (splitedActionText && splitedActionText.length > 0) {
            if (tagName === "title") {
                return removeHtmlTags(splitedActionText[0]);
            } else {
                return removeHtmlTags(splitedActionText[1]);
            }
        }
    };

    const showPendingAction = (val: any, index: number) => {
        let title = "Header Text from API";
        //let pendingAction = (assessmentData?.listPendingAction.find(it => it.Id == val[0].ParentID));
        let pendingAction = assessmentData?.questions?.find((it) => it.Id === val[0].ParentID);
        let h4tags: any = pendingAction?.ActionText?.match("<h4>(.*?)</h4>");
        if (h4tags) {
            title = removeHtmlTags(h4tags[0]);
        }

        return (
            <React.Fragment>
                {val && (
                    <div className="drawer-container">
                        <div className="drawer-header">
                            <div className="row">
                                <div className="col-xs col-no-gutter">
                                    <button
                                        aria-expanded="false"
                                        className="btn-default btn-toggle btn-drawer"
                                        id={"btn-data-storage-devices-" + index}
                                        onClick={() => toggle("data-storage-devices-" + index, "btn-data-storage-devices-" + index)}
                                    >
                                        <span className="btn-toggle-status sr-only">{tLang("resourcesSection.securityAssessmentTab.showText")}</span>
                                        <span className="btn-text">
                                            {`${title} (${val.length}`}
                                            <span className="sr-only">{tLang("resourcesSection.securityAssessmentTab.openActionText")}</span>)
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null" style={{ paddingTop: "0.75rem" }}>
                                    <button
                                        type="button"
                                        className="btn-default btn-link btn-no-padding btn-no-border"
                                        onClick={() => history.push("/resources/security-assessment-wizard?parentID=" + val[0].ParentID)}
                                    >
                                        <span className="btn-text">
                                            {tLang("resourcesSection.securityAssessmentTab.editAnsText")} <span className="sr-only">getGroupHeaderText(val.ParentID)</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="drawer-content padding-left-l" id={"data-storage-devices-" + index} style={{ display: "none" }} aria-hidden="true">
                            {val.map((value: any, index: number) => (
                                <React.Fragment key={`open-action-${index}`}>
                                    <h3 className="sr-only">{parseHTML(value.ActionText, "title")}</h3>
                                    <h4 className="inner-title">{parseHTML(value.ActionText, "title")}</h4>
                                    <p>{parseHTML(value.ActionText, "desc")}</p>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                )}
                <div className="line-divider"></div>
            </React.Fragment>
        );
    };
    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        {tLang("resourcesSection.resourcesTitleText")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="1" />

            <div className="row" id="content">
                <div className="col-xs">
                    {isLoading ? (
                        <div className="box loading"></div>
                    ) : (
                        <React.Fragment>
                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="shield-alt" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("resourcesSection.securityAssessmentTab.securityAssessmentTitle")}</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>
                                            {tLang("resourcesSection.securityAssessmentTab.securityAssessmentDescription")}
                                        </p>
                                    </div>
                                    <div className="box-actions"></div>
                                </div>
                                <div className="box-content">
                                    <button type="button" className="btn-default btn-primary" onClick={onClick}>
                                        <span className="btn-text">
                                                {assessmentData && assessmentData.Rating ? tLang("resourcesSection.securityAssessmentTab.retakeSABtnText") : tLang("resourcesSection.securityAssessmentTab.takeSABtnText")}
                                        </span>
                                    </button>

                                    {assessmentData && assessmentData.Rating && (
                                        <React.Fragment>
                                            <div className="line-divider margin-vertical-m"></div>

                                            <h3 className="inner-title">{tLang("resourcesSection.securityAssessmentTab.scoreText")}</h3>

                                            {ratingList().find((it) => it.title === assessmentData.Rating?.trim())?.htmlDesc}

                                            <div className="space-divider margin-bottom-l"></div>

                                            <button
                                                type="button"
                                                aria-expanded="false"
                                                className="btn-default btn-toggle btn-no-padding"
                                                id="btn_score_readiness"
                                                onClick={() => toggle("score_readiness_details", "btn_score_readiness")}
                                            >
                                                <span className="btn-toggle-status sr-only">Show</span>
                                                    <span className="btn-text">{tLang("resourcesSection.securityAssessmentTab.scoreFactorsText")}</span>
                                            </button>

                                            <div className="card" id="score_readiness_details" style={{ display: "none" }}>
                                                <div className="card-body">
                                                    <ul>
                                                        {ratingList().map((rating: IHtmlItem, ratingIndex: number) => (
                                                            <li key={`rating-${ratingIndex}`}>{rating.htmlDesc}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>

                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="lightbulb" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">{tLang("resourcesSection.securityAssessmentTab.actionPlanText")}</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>
                                            {tLang("resourcesSection.securityAssessmentTab.actionPlanDescription")}
                                        </p>
                                    </div>
                                    <div className="box-actions"></div>
                                </div>

                                <div className="box-content">
                                    <p>
                                        <strong>
                                            <RenderIcons iconName="info-circle" />
                                            &nbsp;{tLang("resourcesSection.securityAssessmentTab.actionsInfoMsg1")} {assessmentData?.listPendingAction?.filter((it) => it.ParentID !== 0).length} {tLang("resourcesSection.securityAssessmentTab.actionsInfoMsg2")}
                                        </strong>
                                    </p>

                                    <p>{tLang("resourcesSection.securityAssessmentTab.actionPlanMsg")}</p>
                                        
                                    <div className="line-divider margin-top-l"></div>

                                    {groupData && (
                                        <div className="drawer-container">
                                            {Object.entries(groupData)?.map(([key, val], index) => (
                                                <div key={"pendingActions-" + index} className={"drawer-content padding-left-" + index}>
                                                    {showPendingAction(val, index)}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default SecurityAssessment;
